import type { Artifact } from "@artifacts/artifactsClient";
import {
  faDownload,
  faFile,
  faFileAudio,
  faFileLines,
  faFilePdf,
  faImage,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RecordCard } from "@scribenote/brian-design-system";
import { formatDateTime } from "@utils/format-date";

const kindIcon = (kind: string) => {
  switch (kind) {
    case "recording":
      return faFileAudio;
    case "pdf":
      return faFilePdf;
    case "image":
      return faImage;
    case "note":
      return faFileLines;
    default:
      return faFile;
  }
};

export const ArtifactCard = ({
  artifact,
  onClick,
}: {
  artifact: Artifact;
  onClick?: () => void;
}) => {
  const written = (
    <span className="flex items-center gap-3">
      <FontAwesomeIcon
        icon={kindIcon(artifact.kind)}
        className="text-annotation"
        aria-hidden="true"
      />
      <span className="min-w-0 flex-1">
        <span className="block truncate text-ink">
          {artifact.filename ?? artifact.kind}
        </span>
        <time className="block text-xs text-annotation">
          {formatDateTime(artifact.createdAt)}
        </time>
      </span>
      {onClick ? (
        <FontAwesomeIcon
          icon={faDownload}
          className="text-annotation"
          aria-hidden="true"
        />
      ) : (
        <span className="text-xs capitalize text-annotation">
          {artifact.status}
        </span>
      )}
    </span>
  );

  return (
    <RecordCard
      onClick={onClick}
      label={
        onClick ? `Download ${artifact.filename ?? artifact.kind}` : undefined
      }
      data-testid={`artifact-card-${artifact.id}`}
    >
      {written}
    </RecordCard>
  );
};
